var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../EventEmitter", "./LayoutElement", "./LayoutElement", "../../lib/interactjs/dist/interact"], function (require, exports, EventEmitter_1, LayoutElement_1, LayoutElement_2, interact) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LayoutDesigner = (function (_super) {
        __extends(LayoutDesigner, _super);
        function LayoutDesigner(root, id) {
            if (id === void 0) { id = ""; }
            var _this = _super.call(this) || this;
            _this.elementClassName = "LayoutElement";
            _this.elementSelectedClassName = "SelectedLayoutElement";
            _this.nextFreeId = 0;
            _this.OnElementSelected = "OnElementSelected";
            _this.OnElementDeselected = "OnElementDeselected";
            _this.activeLayer = 0;
            _this.elementIsInDropzone = true;
            _this.root = root;
            _this.elements = new Array();
            _this.designerId = id;
            _this.SetRootSize();
            return _this;
        }
        Object.defineProperty(LayoutDesigner.prototype, "SelectedElement", {
            get: function () {
                return this.selectedElement;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LayoutDesigner.prototype, "ActiveLayer", {
            get: function () {
                return this.activeLayer;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LayoutDesigner.prototype, "ElementIsInDropzone", {
            get: function () {
                return this.elementIsInDropzone;
            },
            enumerable: true,
            configurable: true
        });
        LayoutDesigner.prototype.SetActiveLayer = function (layerIndex) {
            this.activeLayer = layerIndex;
            this.DeselectElement();
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.LayerIndex == layerIndex) {
                    iElement.element.removeClass("InactiveRect");
                }
                else {
                    iElement.element.addClass("InactiveRect");
                }
            }
        };
        LayoutDesigner.prototype.ClearAllElements = function () {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                iElement.Remove();
            }
            this.elements = new Array();
            this.selectedElement = null;
            this.nextFreeId = 0;
        };
        LayoutDesigner.prototype.SetRootSize = function () {
            console.log("root width: " + this.root.width());
            console.log("root height: " + this.root.height());
        };
        LayoutDesigner.prototype.UnsetAllInteractions = function () {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                iElement.UnsetInteraction();
            }
        };
        LayoutDesigner.prototype.ApplyAllInteractionsToAllElements = function () {
            this.UnsetAllInteractions();
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.LayerIndex == this.activeLayer || this.activeLayer == -1)
                    this.ApplyInteractions(iElement);
            }
        };
        LayoutDesigner.prototype.ApplyDragInteractionToAllElements = function () {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.LayerIndex == this.activeLayer || this.activeLayer == -1)
                    this.ApplyDragInteraction(iElement);
            }
        };
        LayoutDesigner.prototype.ApplyGridDragInteractionToAllElements = function (gridX, gridY) {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.LayerIndex == this.activeLayer || this.activeLayer == -1)
                    iElement.ApplyGridDrag(gridX, gridY);
            }
        };
        LayoutDesigner.prototype.ApplyResizeInteractionToAllElements = function () {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.LayerIndex == this.activeLayer || this.activeLayer == -1)
                    this.ApplyResizeInteraction(iElement);
            }
        };
        LayoutDesigner.prototype.ApplyTouchInteractionToAllElements = function () {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.LayerIndex == this.activeLayer || this.activeLayer == -1)
                    this.ApplyTouchInteraction(iElement);
            }
        };
        LayoutDesigner.prototype.ApplyTouchInteraction = function (layoutElement) {
            layoutElement.ApplyTouch();
        };
        LayoutDesigner.prototype.ApplyDragInteraction = function (layoutElement) {
            var snappingPoints = new Array();
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (layoutElement == iElement)
                    continue;
                this.AddSnappingPoints(iElement, snappingPoints);
            }
            layoutElement.ApplyDrag(snappingPoints);
        };
        LayoutDesigner.prototype.ApplyResizeInteraction = function (layoutElement) {
            var snappingPoints = new Array();
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (layoutElement == iElement)
                    continue;
                this.AddSnappingPoints(iElement, snappingPoints);
            }
            layoutElement.ApplyResize(snappingPoints);
        };
        LayoutDesigner.prototype.ApplyInteractions = function (layoutElement) {
            var snappingPoints = new Array();
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (layoutElement == iElement)
                    continue;
                this.AddSnappingPoints(iElement, snappingPoints);
            }
            layoutElement.ApplyDrag(snappingPoints);
            layoutElement.ApplyResize(snappingPoints);
            layoutElement.ApplyTouch();
        };
        LayoutDesigner.prototype.ApplyDropzone = function (dropZoneSelector, elementSelector) {
            var host = this;
            interact(dropZoneSelector)
                .dropzone({
                accept: elementSelector,
                overlap: 0.5,
                ondropactivate: function (event) {
                    host.elementIsInDropzone = false;
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget;
                    var dropzoneElement = event.target;
                    host.elementIsInDropzone = true;
                    host.FireEvent(LayoutElement_1.LayoutElement.OnElementEnteredDropzone, { htmlElement: draggableElement });
                },
                ondragleave: function (event) {
                    var draggableElement = event.relatedTarget;
                    var dropzoneElement = event.target;
                    host.elementIsInDropzone = false;
                    host.FireEvent(LayoutElement_1.LayoutElement.OnElementLeftDropzone, { htmlElement: draggableElement });
                },
                ondrop: function (event) {
                    var draggableElement = event.relatedTarget;
                    var dropzoneElement = event.target;
                    host.FireEvent(LayoutElement_1.LayoutElement.OnElementDroppedInDropzone, { htmlElement: draggableElement });
                },
                ondropdeactivate: function (event) {
                }
            });
        };
        LayoutDesigner.prototype.SetAspectRatio = function (format, active) {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                iElement.aspectRatio = format;
                iElement.preserveAspectRatio = active;
            }
        };
        LayoutDesigner.prototype.ElementDropped = function (sender, data) {
            var element = this.GetElement(data.id);
            this.SelectElement(element);
            this.FireEvent(LayoutElement_1.LayoutElement.OnElementDropped, { layoutElement: element });
        };
        LayoutDesigner.prototype.ElementMoved = function (sender, data) {
            this.FireEvent(LayoutElement_1.LayoutElement.OnElementMoved, { elementId: data.id });
        };
        LayoutDesigner.prototype.SelectElement = function (element) {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                iElement.Deselect();
            }
            element.Select();
            this.selectedElement = element;
            this.FireEvent(this.OnElementSelected, this.selectedElement);
        };
        LayoutDesigner.prototype.DeselectElement = function () {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                iElement.Deselect();
            }
            this.selectedElement = null;
            this.FireEvent(this.OnElementDeselected, this.selectedElement);
        };
        LayoutDesigner.prototype.ElementTouched = function (sender, data) {
            var element = this.GetElement(data.id);
            this.SelectElement(element);
            this.FireEvent(LayoutElement_1.LayoutElement.OnElementTouched, { layoutElement: element });
        };
        LayoutDesigner.prototype.DeleteSelectedLayoutElement = function () {
            var index = this.GetElementIndex(this.selectedElement);
            if (index == -1)
                return;
            this.selectedElement.Remove();
            this.elements.splice(index, 1);
        };
        LayoutDesigner.prototype.DeleteLayoutElement = function (layoutElement) {
            var index = this.GetElementIndex(layoutElement);
            if (index == -1)
                return;
            layoutElement.Remove();
            this.elements.splice(index, 1);
        };
        LayoutDesigner.prototype.DeleteElementRecursively = function (layoutElement) {
            if (layoutElement.childrenLayoutElements != null)
                for (var _i = 0, _a = layoutElement.childrenLayoutElements; _i < _a.length; _i++) {
                    var element = _a[_i];
                    this.DeleteElementRecursively(element);
                    this.DeleteLayoutElement(element);
                }
        };
        LayoutDesigner.prototype.DeleteLayoutElementRecursively = function (layoutElement) {
            if (layoutElement.childrenLayoutElements != null)
                if (layoutElement.childrenLayoutElements.length > 0) {
                    this.DeleteElementRecursively(layoutElement);
                }
            this.DeleteLayoutElement(layoutElement);
        };
        LayoutDesigner.prototype.CreateLayoutElement = function (width, height, x, y, parent, layout, ignoreTransform) {
            if (width === void 0) { width = 100; }
            if (height === void 0) { height = 100; }
            if (x === void 0) { x = 0; }
            if (y === void 0) { y = 0; }
            if (parent === void 0) { parent = null; }
            if (layout === void 0) { layout = null; }
            if (ignoreTransform === void 0) { ignoreTransform = false; }
            if (parent == null)
                parent = this.root;
            var id = this.nextFreeId.toString();
            var layoutElement = new LayoutElement_1.LayoutElement(width, height, x, y, this.designerId + "LayoutElement" + id, parent, layout, ignoreTransform);
            if (this.elementClassName != "")
                layoutElement.ClassName = this.elementClassName;
            if (this.elementSelectedClassName != "")
                layoutElement.SelectedClassName = this.elementSelectedClassName;
            layoutElement.LayerIndex = this.activeLayer;
            layoutElement.AddEventListener(LayoutElement_1.LayoutElement.OnElementTouched, this.ElementTouched.bind(this));
            layoutElement.AddEventListener(LayoutElement_1.LayoutElement.OnElementDropped, this.ElementDropped.bind(this));
            layoutElement.AddEventListener(LayoutElement_1.LayoutElement.OnElementMoved, this.ElementMoved.bind(this));
            this.elements.push(layoutElement);
            this.nextFreeId++;
            return layoutElement;
        };
        LayoutDesigner.prototype.CreateLayoutElementRelative = function (widthPercent, heightPercent, xPercent, yPercent, parent, layout, ignoreTransform) {
            if (widthPercent === void 0) { widthPercent = 1; }
            if (heightPercent === void 0) { heightPercent = 1; }
            if (xPercent === void 0) { xPercent = 0; }
            if (yPercent === void 0) { yPercent = 0; }
            if (parent === void 0) { parent = null; }
            if (layout === void 0) { layout = null; }
            if (ignoreTransform === void 0) { ignoreTransform = false; }
            var width = this.root.outerWidth() * widthPercent;
            var height = this.root.outerHeight() * heightPercent;
            var x = this.root.outerWidth() * xPercent;
            var y = this.root.outerHeight() * yPercent;
            var layoutElement = this.CreateLayoutElement(width, height, x, y, parent, layout, ignoreTransform);
            layoutElement.pX = xPercent;
            layoutElement.pY = yPercent;
            return layoutElement;
        };
        LayoutDesigner.prototype.AddSnappingPoints = function (layoutElement, snappingPoints) {
            var rect = layoutElement.GetRect();
            var snappingPoint1 = new LayoutElement_2.SnappingPoint();
            snappingPoint1.x = rect.left;
            snappingPoint1.y = rect.bottom;
            snappingPoints.push(snappingPoint1);
            var snappingPoint2 = new LayoutElement_2.SnappingPoint();
            snappingPoint2.x = rect.left;
            snappingPoint2.y = rect.top;
            snappingPoints.push(snappingPoint2);
            var snappingPoint3 = new LayoutElement_2.SnappingPoint();
            snappingPoint3.x = rect.right;
            snappingPoint3.y = rect.top;
            snappingPoints.push(snappingPoint3);
            var snappingPoint4 = new LayoutElement_2.SnappingPoint();
            snappingPoint4.x = rect.right;
            snappingPoint4.y = rect.bottom;
            snappingPoints.push(snappingPoint4);
        };
        LayoutDesigner.prototype.GetElementWithSameId = function (contentObject) {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.object.Id == contentObject.Id)
                    return iElement;
            }
            return null;
        };
        LayoutDesigner.prototype.GetElement = function (id) {
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                if (iElement.id == id)
                    return iElement;
            }
            return null;
        };
        LayoutDesigner.prototype.GetElementIndex = function (layoutElement) {
            return this.elements.indexOf(layoutElement);
        };
        LayoutDesigner.prototype.GetElements = function () {
            return this.elements;
        };
        LayoutDesigner.prototype.RecalculateElementsTransform = function () {
            console.log("RecalculateElementsTransform");
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var iElement = _a[_i];
                iElement.RecalculateTransform();
            }
        };
        return LayoutDesigner;
    }(EventEmitter_1.EventEmitter));
    exports.LayoutDesigner = LayoutDesigner;
});
//# sourceMappingURL=LayoutDesigner.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/LayoutDesigner/LayoutDesigner.js
// module id = 76
// module chunks = 0